import React, { Component } from "react";
import { Button as AntButton } from "antd";
import "./Button.scss";

class Button extends Component {
  render() {
    const props = { ...this.props };
    props.className = "pp-button " + (props.className || "");
    if (props.type) {
      props.className += ` btn-${props.type}`;
    }
    if (props.size) {
      props.className += ` btn-${props.size}`;
    }
    return <AntButton {...props}>{props.children}</AntButton>;
  }
}

export default Button;
